import { Link } from "react-router-dom";
import { useAuth } from "@/state/AuthContext";
import { ResearchLauncher } from "@/components/ResearchLauncher";
import { COMPANY, ICP_QUERY_URL, mailto } from "@/lib/branding";

export function LandingPage() {
  const auth = useAuth();
  return <div className="research-home">
    <header className="research-public-nav">
      <Link to="/" className="brand-mark"><span className="research-monogram" aria-hidden="true">研</span>研鉴</Link>
      <nav aria-label="网站导航"><Link to="/demo">样例报告</Link><Link to="/guide">使用说明</Link>
        <Link className="research-login" to={auth.user ? "/app" : "/auth"}>{auth.user ? "工作台" : "登录"} <span aria-hidden="true">↗</span></Link></nav>
    </header>
    <main className="research-public-main">
      <header className="research-intro"><p className="research-overline">研鉴 / RESEARCH WORKSPACE</p>
        <h1 className="research-promise"><span>检索文献</span><span>核查材料</span><span>回到原始证据</span></h1>
      </header>
      <ResearchLauncher />
      <section className="research-methods" aria-label="如何使用结果">
        <div><h2>来源可追溯</h2><p>保留原始文献链接，支持题录导出。AI 摘要仅供辅助阅读。</p></div>
        <div><h2>证据可复核</h2><p>标注异常位置与核查范围。异常提示不等同于学术不端认定，未检出不排除潜在问题。</p></div>
        <Link to="/demo" className="research-sample-link">样例报告 <span aria-hidden="true">↗</span></Link>
      </section>
    </main>
    <footer className="research-footer"><div><span>研鉴 ResGuard</span><nav aria-label="法律与联系"><Link to="/terms">用户协议</Link><Link to="/privacy">隐私政策</Link><a href={mailto()}>联系我们</a></nav></div>
      <p>{COMPANY.name} · <a href={ICP_QUERY_URL} target="_blank" rel="noreferrer">{COMPANY.icp}</a></p>
    </footer>
  </div>;
}
